import clsx from 'clsx';
import { forwardRef, HtmlHTMLAttributes } from 'react';

import styles from './arrow.module.scss';

export const Arrow = forwardRef((props: ArrowProps, ref: any) => {
  const { size, attributes, ...rest } = props;

  return (
    <div
      className={clsx(styles.arrowContainer, size === 'small' && styles.small, size === 'medium' && styles.medium)}
      ref={ref}
      {...attributes}
      {...rest}
    >
      <div className={styles.arrowHolder}>
        <div className={clsx(styles.arrow, 'arrow')} />
      </div>
    </div>
  );
});

interface ArrowProps extends HtmlHTMLAttributes<HTMLDivElement> {
  size?: 'default' | 'small' | 'medium';
  attributes?: any;
}
